<template lang="pug">
section.filmstrip
  h3.title( v-if='title' ) {{ title }}
  .content( v-if='contents.length > 0' )
    carousel(
      :per-page='1'
      :per-page-custom=`[[540,2],[780,3],[1020,4],[1220,5],[1500,6],
                        [2740,7],[1980,8],[2220,9],[2460,11],[2700,12]]`
      :navigation-enabled='true'
      :pagination-enabled='false'
      :scroll-per-page='false'
    )
      slide( v-for='( item, index ) in contents' :key='index' )
        b-card.item(
          :title="item.title ? item.title.rendered: ''"
          :img-src='item.thumbnail'
          :class=`[ { current: item.id == current }, cardClasses( item )]`
          img-top
        )
          p.card-text(
             v-html=`item.content ? item.content.rendered
                     : item.caption ? item.caption.rendered : ''`)
          b-btn.float-right.watching(
            v-if='item.id == current'
            variant='link'
            size='lg'
            v-scroll-to=`{ el: '#featured', container: '.page',
                              x: false, y: true }`
          )
            | now {{ sayAction( item )}}ing
          watch-button( v-else :target='item' )
      .swiper-button-prev( slot='button-prev' )
      .swiper-button-next( slot='button-next' )
      .swiper-scrollbar( slot='scrollbar' )
  template( v-else )
    .message.empty-list nothing to show yet
    a.loadmore(
      v-if='query'
      href='#'
      @click.prevent='loadMore'
    ) refresh
</template>

<script lang="js">
import { Carousel, Slide } from 'vue-carousel'
import mediaActions from '@/mixins/media-actions'
import WatchButton from './watch-button'
// TODO: add more

export default {
  name: 'filmstrip',
  mixins: [ mediaActions ],
  components: { WatchButton, Carousel, Slide },
  props: {
    title: {
      type: String,
      default: ''
    },
    contents: {
      type: Array,
      default: () => []
    },
    current: {
      type: Number,
      default: 0
    },
    query: {
      type: String,
      default: ''
    },
    more: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
@import "~breakpoint-sass/stylesheets/breakpoint";
@import "@/scss/vars";

section.filmstrip {
  .VueCarousel {
    background: rgba(0,0,0,0.05);
    border-bottom: 1px solid white;
    border-top: 1px solid rgba(0,0,0,0.05);
  }
}
.content-list, .filmstrip {
  margin-top: 40px;
  margin-bottom: 40px;
  min-height: 100px;
  max-width: none;
  >.title {
    text-transform: capitalize;
    padding: 2px;
    border-bottom: 1px solid rgba(155,100,100,0.2);
  }
  .card.item {
    width: 16em;
    margin: 2px;
    border: 0 none;
    box-shadow: 0 1px 4px rgba(0,0,0,0.1);
    background: #024;
    &.hidden {
      display: flex !important;
      opacity: 0.5;
    }
    &.current {
      background: #444;
      color: white;
    }
    .card-img-top {
      margin: 0;
      height: 10em;
      object-fit: cover;
    }
    .card-title {
      font-weight: bold;
      font-variant: small-caps;
      height: 3em;
      overflow-y: hidden;
    }
    .card-body {
      padding: 8px;
    }
    .card-text {
      height: 9em;
      overflow-y: auto;
      padding: 0 2px;
    }
    .watching {
      font-weight: bold;
      color: orange;
    }
  }
}

</style>
